<template>
  <BreadCrumb PageTitle="Bons distribution" />
  <ListNotes />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ListNotes from "@/components/Notes/Distribution/ListNote.vue";

export default defineComponent({
  name: "ListNotesPage",
  components: {
    BreadCrumb,
    ListNotes,
  },
});
</script>